import { render, staticRenderFns } from "./HistoricoFilas.vue?vue&type=template&id=1f6feb53"
import script from "./HistoricoFilas.vue?vue&type=script&lang=js"
export * from "./HistoricoFilas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports